import { render, staticRenderFns } from "./PrimarySelector.vue?vue&type=template&id=6f651fd4&scoped=true&"
import script from "./PrimarySelector.vue?vue&type=script&lang=js&"
export * from "./PrimarySelector.vue?vue&type=script&lang=js&"
import style0 from "./PrimarySelector.vue?vue&type=style&index=0&id=6f651fd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f651fd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
